import { BUSINESS_TIMEZONE } from '@omecare/utils';
import { intlFormat } from 'date-fns/intlFormat';
import { isSameDay } from 'date-fns/isSameDay';

export type EventOccurence = {
  id: string | null;
  allday: boolean;
  start: Date;
  end: Date | null;
};

export type EventOccurencePeriod = {
  isSameDay: boolean;
  allday: boolean;
  singleDay: {
    date: string;
    hours: {
      start: string;
      end: string;
    };
  };
  dayHours: {
    start: string;
    end: string;
  };
};
export const useEventOccurencePeriodInformation = ({
  event,
}: {
  event: EventOccurence;
}): EventOccurencePeriod => {
  const hours = {
    start: intlFormat(event.start, {
      timeZone: BUSINESS_TIMEZONE,
      hour: 'numeric',
    }),
    end: event.end
      ? intlFormat(event.end, { timeZone: BUSINESS_TIMEZONE, hour: 'numeric' })
      : '',
  };

  const startDay = intlFormat(event.start, {
    timeZone: BUSINESS_TIMEZONE,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  });

  let endDayHours = '';
  if (event.end) {
    endDayHours =
      intlFormat(event.end, {
        timeZone: BUSINESS_TIMEZONE,
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      }) +
      ' - ' +
      hours.end;
  }

  const startDayHours =
    intlFormat(event.start, {
      timeZone: BUSINESS_TIMEZONE,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    }) +
    ' - ' +
    hours.start;

  const isSingleDay = event.allday
    ? true
    : !event.end || isSameDay(event.start, event.end);

  return {
    isSameDay: isSingleDay,
    singleDay: {
      date: startDay,
      hours,
    },
    allday: event.allday,
    dayHours: {
      start: startDayHours,
      end: endDayHours,
    },
  };
};
